// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__1H5OD","vLegacy":"SelectSecondary_vLegacy__1KQLG","error":"SelectSecondary_error__gEdvF","disabled":"SelectSecondary_disabled__8OEuB"};